import Modal from "react-modal";
import {Produto} from "../../components/CardProduto/CardProduto";
import Styles from "./ModalExclusaoItem.module.css";
import {useTranslation} from "react-i18next";

interface ModalConfirmacaoProps {
    isOpen: boolean;
    handleExcluir: (optionalParam?: any) => void;
    handleCancelar: () => void;
    produto: Produto; // Adicione esta linha se você precisa passar um produto para o modal
}

export default function ModalExcluirItem({
    isOpen,
    handleExcluir,
    handleCancelar,
    produto, // Adicione esta linha para receber o produto como prop
}: ModalConfirmacaoProps): JSX.Element {
    const handleExcluirDefault = (optionalParam?: any) => {
        handleExcluir(optionalParam);
        handleCancelar();
    };

    const { t } = useTranslation();

    return (
        <Modal isOpen={isOpen} className={Styles.ModalExcluirItem}>
            <div className={Styles.modalContainer}> 
                    <div className={Styles.titleContainer}>
                        <h1 className={Styles.title}>{t('ModalExclusao.exclusao')}</h1>
                    </div> 

                <div className={Styles.modalCabecalho}>
                    <p className={Styles.cabecalhoText}>{t('ModalExclusao.certeza')}</p>
                    <p className={Styles.nomeproduto}>{produto.name}</p>
                    <p className={Styles.cabecalhoText}>{t('ModalExclusao.loja')}</p>
                </div>
                <div className={Styles.buttons}>
                    <button onClick={handleCancelar}>
                    {t('ModalExclusao.cancelar')}
                    </button>
                    <button onClick={handleExcluirDefault}>
                    {t('ModalExclusao.excluir')}
                    </button>
                </div>
            </div>
        </Modal>
    );
}
